import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combina classi Tailwind risolvendo conflitti.
 * Standard shadcn/ui — usa questo invece di concatenare stringhe.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
